import {Component, ElementRef, OnInit, ViewChild, OnDestroy, AfterViewInit, Renderer2} from '@angular/core';
import {ActivatedRoute, NavigationEnd, Router, RouterStateSnapshot} from '@angular/router';
import {TaskService} from '@components/my-web-desk/new-task-modal/task.service';
import {ProventumApiService} from '@app/services/proventum-api.service';
import {Globals} from '@app/services/globals.service';
import {ToastrService} from 'ngx-toastr';
import {NotificationService} from '@app/services/notification/notification.service';
import {MatDialog} from '@angular/material/dialog';
import {NewTaskModalComponent} from '@components/my-web-desk/new-task-modal/new-task-modal.component';
import {DialogConfirmComponent} from '@common-components/dialogues/dialog-confirm/dialog-confirm.component';
import {Observable, Subscription} from 'rxjs';
import {environment} from '@env/environment';
import {ConstantsService} from '@app/services/constants/constants.service';
import {DialogAlertComponent} from '@components/view-task/dialog-alert/dialog-alert/dialog-alert.component';
import {History} from '@app/interfaces/history';
import {UploadService} from '@common-components/file-upload/upload.service';
import {Location} from '@angular/common';
import {BridgeService} from '@app/services/bridge/bridge.service';
import {DatePipe} from "@angular/common";
import {SidebarService} from "@components/my-web-desk/sidebar/sidebar.service";
import {SidebarComponent} from "@components/my-web-desk/sidebar/sidebar.component";
import {BackendResponse} from "@app/interfaces/backendResponse";
import {filter} from 'rxjs/operators';
import {Task} from "@app/interfaces/task";


@Component({
    selector: 'app-view-task',
    templateUrl: './view-task.component.html',
    styleUrls: ['./view-task.component.css']
})
export class ViewTaskComponent implements OnInit, OnDestroy {

    // API_url = environment.apiURL;
    task: object;
    taskId = '';
    title = '';
    description = '';
    project = [];
    taskViews = '';
    progressProcent = '';
    allTaskWatchers = [];

    attachments = [];
    assignedArray = [];
    assignedForTask: any = [];
    commentsArray = [];
    watchers: any = [];
    commentText = '';
    assigned = [];
    subtasks = [];
    createdAt = '';
    estimateTime = '';
    deadline = '';
    comments = '';
    trackTime= '';
    subtasksLength: number = 0;
    users: any = [];
    previewTableWatchers: boolean;
    eye: boolean;

    status = '';
    buttonClass = '';
    apiURL = environment.apiURL;
    type = '';
    validatorPermission = false;
    avatarWidth = 30;

    hashes = [];
    percentDone = 100;
    uploadSuccess: boolean;
    commentAttachments = [];

    taskValidators = [];
    execution;
    creator = localStorage.getItem('userId');
    loader = false;
    statusName = '';
    sort = '';
    buttonDisabled = false;
    history = [];
    user: any[] = [];
    validatorsData: any = [];
    taskCreatorData: any = [];
    endTime = '';
    identifier = '';
    meetingTime = {start: '', end: ''};
    reminderTime = {start: ''};
    creatorId: number;

    today = new Date();
    createdAtString = '';
    tabs: any;

    // sidebarSubscription: Subscription;
    num = 0;
    sidebarState = true;
    cliUrl = environment.cliURL;

    myFiles: any[] = [];

    permission = false;

    @ViewChild('fileUpload', {static: false}) fileUpload: ElementRef;
    @ViewChild('autoResizedTextArea') resizedTextArea: ElementRef;

    routesSubscription: Subscription;

    constructor(private activateRoute: ActivatedRoute,
                public taskService: TaskService,
                public proventumApiService: ProventumApiService,
                public globals: Globals,
                private toastr: ToastrService,
                private notifyService: NotificationService,
                private matDialog: MatDialog,
                public constants: ConstantsService,
                public dialog: MatDialog,
                public uploadService: UploadService,
                private location: Location,
                private bridge: BridgeService, private datePipe: DatePipe,
                public sidebarService: SidebarService,
                public renderer: Renderer2,
                private router: Router
    ) {
    }


    setWatcher(id) {
        this.buttonDisabled = true;
        let data = {
            id: id,
            sort: this.sort
        };
        this.taskService.setWathcer(JSON.stringify(data)).subscribe(async (result) => {
            if (result.type === 'success') {
                this.toastr.success('Od sada pratite ovaj zadatak.');
                this.eye = true;
                this.watchers = [];
                this.previewTableWatchers = true;
                const function1 = await this.getWatchers();
                this.buttonDisabled = false;
            }
        });
    }

    removeWatcher(id) {
        this.buttonDisabled = true;
        const data = {
            id: id,
            sort: this.sort
        };
        this.taskService.removeWatcher(data).subscribe(async (res) => {
            if (res.type === 'success') {
                this.eye = false;
                this.toastr.success('Ne pratite više ovaj zadatak.');
                this.watchers = [];
                await this.getWatchers();
                this.buttonDisabled = false;
            }
        });

    }

    getAllApplicationUser() {
        this.proventumApiService.getUsers().subscribe((data) => {
            this.globals.allAppUsers = data;
            this.users = data;
        });
    }

    ngOnDestroy() {
        this.routesSubscription.unsubscribe();
    }


    async ngOnInit() {
        this.routesSubscription = this.router.events.pipe(
            filter((event) => event instanceof NavigationEnd)
        ).subscribe((x: NavigationEnd) => {
            if (this.activateRoute.snapshot.params['taskId'] !== this.taskId) {
                this.ngOnInit();
            }
        });

        this.creatorId = this.constants.getLoggedInUserId();
        this.validatorPermission = false;


        if (this.constants.creator_id == '') {
            const function5 = await this.getUserData();
            if (!function5) {
                this.toastr.error('Došlo je do greške. Molimo Vas obratite se korisničkoj podršci.');
            }
        } else {
            this.user = this.constants.userData;
        }


        this.loader = true;
        this.appendClassesHandler();

        await this.getUsers();
        const type = this.activateRoute.snapshot.routeConfig.path.split('/')[0];
        this.taskId = this.activateRoute.snapshot.params['taskId'];

        let str = this.taskId.split('*');
        this.taskId = str !== undefined ? str[0] : this.taskId;
        const function1 = this.getTaskDetails();
        const function2 = await this.getComments(this.taskId);

        if (this.allTaskWatchers.length > 0) {
            this.allTaskWatchers.forEach(value => {

                let item = this.users.find(x => x.id == value);
                this.watchers.push(item);
            });
        }
        let dataForTrackTime = {
          '_id': this.taskId,
          'sort' : "task"
        };

        this.trackTime = await this.taskService.getTaskDurationRequest(dataForTrackTime).toPromise();
        if(this.trackTime === "")
        {
          const res: any = await this.taskService.getTaskData(this.taskId).toPromise();
          this.trackTime = res.data.trackTime;
        }

        this.loader = false;
    }


    getComments(id) {
        this.taskService.getComments(id).subscribe((data: any[]) => {
            this.commentsArray = data;

        });
    }

    getAssigned(assigned) {
        this.assignedArray = this.proventumApiService.getAssigned(assigned);
    }

    async addComment() {
        await this.taskService.addComment(this.taskId, this.commentText, this.sort, this.commentAttachments).subscribe(async (res) => {
            if (res.type === 'success') {
                await this.getComments(this.taskId);
                this.commentText = '';
                this.commentAttachments = [];

                let data = {
                    'type': 'comment',
                    'action': 'insert',
                    'user_id': parseInt(this.creator),
                    'task_id': this.taskId,
                    'sort': this.task['sort'],
                    'message': 'Korisnik ' + this.user['first_name'] + ' ' + this.user['last_name'] + ' je dodao komentar.',
                    'data': null,
                    'task_identifier': this.task['identifier']
                };

                let assignedArray: any[] = this.task['assigned'];
                let validatorsArray: any[] = this.task['validator_id'];
                let total: any[] = assignedArray.concat(validatorsArray);
                total = total.filter(item => item !== this.creatorId);

                if (total.length > 0) {
                    let link = this.cliUrl + '/view-task/' + this.task['_id'];
                    let notif = {
                        notification: {
                            title: `${this.user['first_name']} ${this.user['last_name']} je dodao/la komentar na zadatak`,
                            description: 'Zadatak: ' + this.task['title'],
                            employers: total,
                            type: 'informacija',
                            link: link
                        }
                    };

                    const fun1 = await this.bridge.sendDataViaBridge(notif);
                }

            }
        }, error => {
            console.log(error);
        });

    }

    async getWatchers() {
        this.allTaskWatchers = [];
        this.watchers = [];
        let response: Observable<any>;
        response = await this.taskService.getTaskData(this.taskId);
        response.subscribe(async result => {
            if (result['type'] === 'success') {
                let data = result['data'];
                this.allTaskWatchers = data['watcher_id'];
                if (this.allTaskWatchers.length > 0) {
                    const wat = await this.getDataForUsersById(this.allTaskWatchers);
                    this.watchers = wat;
                } else {
                    this.previewTableWatchers = false;
                }
            }
        });


    }

    addSubtask(id) {
        this.matDialog.open(NewTaskModalComponent, {
            disableClose: true,
            height: '600px',
            width: '800px',
            data: {
                id: 'sub-task',
                mode: 'copy',
                sort: 'subtask',
                task: this.task,
                sprintId: this.task['sprint_id']
            }
        })
            .afterClosed().subscribe((result) => {
            if (result) {
                this.getSubtasks(this.taskId);
            }

        });
    }

    getSubtasks(id) {
        this.taskService.getSubtasks(id).subscribe(result => {
            this.subtasks = result;
            this.tabs = false;
        });
    }


    editTask(id) {
        this.matDialog.open(NewTaskModalComponent, {
            disableClose: true,
            height: '600px',
            width: '800px',
            data: {
                mode: 'edit',
                task: this.task,
                sort: 'task'
            }
        })
            .afterClosed().subscribe(response => {
            if (response) {
                this.ngOnInit();
            }
        });


    }

    editSubtask(id) {
        this.matDialog.open(NewTaskModalComponent, {
            disableClose: true,
            height: '600px',
            width: '800px',
            data: {
                mode: 'edit',
                task: this.task,
                sort: 'subtask'
            }
        })
            .afterClosed().subscribe(response => {
            if (response) {
                this.ngOnInit();
            }

        });
    }


    deleteTask(id) {
        const dialogRef = this.matDialog.open(DialogConfirmComponent, {
            width: 'auto',
            height: '16%',
            disableClose: true,
        });
        dialogRef.afterClosed().subscribe(result => {
            if (result === true) {
                this.taskService.deleteTask(id).subscribe(res => {
                    if (res.type === 'success') {
                        setTimeout(() => {
                            this.toastr.success('Uspjesno ste obrisali task.');
                        }, 5000);
                        this.buttonClass = 'status-button-deleted';
                        this.goBack();


                    }
                });
            }
        });
    }

    changeTaskStatus(event, id) {
        if (event.value === 'todo' || event.value === 'inprogress') {
            if (event.value === 'inprogress') {
                this.statusName = 'U radu';
                this.buttonClass = 'status-button-inprogress';
            } else {
                this.statusName = 'Otvoreno';
                this.buttonClass = 'status-button-todo';
            }

        } else if (event.value === 'postponed') {
            const dialog = this.dialog.open(DialogAlertComponent, {
                disableClose: true,
                width: '20%',
                height: '20%',
                data: {
                    dateTime: this.deadline,
                    task: this.task
                }
            });
            dialog.afterClosed().subscribe(() => {
                this.statusName = 'Odloženo';
                this.ngOnInit();
            });
            this.buttonClass = 'status-button-postponed';

        } else if (event.value === 'ddone') {
            this.statusName = 'Završeno';
            this.buttonClass = 'status-button-done';
        } else {
            this.buttonClass = 'status-button-canceled';
            this.statusName = 'Otkazano';
        }


        if (event.value !== 'postponed') {
            const value = event.value;
            const task = {
                _id: this.task['_id'],
                sort: this.task['sort'],
                project_id: this.task['project_id'],
                trackTime: this.trackTime

            };
            let data = {
                status: value,
                task: JSON.stringify(task)
            };
            const response = this.taskService.changeStatusOfTask(data).subscribe(result => {
                    if (result.type === 'success') {
                        let message = event.value === 'canceled' ?
                            `Korisnik  ${this.user['first_name']} ${this.user['last_name']} je otkazao zadatak.` :
                            `Korisnik  ${this.user['first_name']} ${this.user['last_name']} je promijenio status u "${this.statusName}."`;

                        const items = {
                            task_id: this.task['_id'],
                            type: 'status',
                            action: 'update',
                            user_id: parseInt(this.creator),
                            sort: this.task['sort'],
                            trackTime: this.trackTime,
                            message: message,
                            data: {type: event.value},
                            task_identifier: this.task['identifier']
                        };
                        this.toastr.success(result.message);
                        let fun2 = this.taskService.taskChange(items).subscribe((response: BackendResponse) => {
                            if (response.type == 'success') {
                                
                            }
                        });

                        if (event.value === 'canceled' || event.value === 'ddone') {
                            let assignedArray: any[] = this.task['assigned'];
                            let validatorsArray: any[] = this.task['validator_id'];
                            let total: any[] = assignedArray.concat(validatorsArray);
                            total = total.filter(item => item !== this.creatorId);


                            if (total.length > 0) {
                                let link =  this.cliUrl + '/view-task/' + this.task['_id'];
                                let notif = {
                                    notification: {
                                        title: message,
                                        description: 'Zadatak: ' + this.task['title'],
                                        employers: total,
                                        type: 'informacija',
                                        link: link
                                    }
                                };

                                const fun1 = this.bridge.sendDataViaBridge(notif);
                            }
                        }


                    } else if (result.type === 'info') {
                        this.toastr.info(result.message);
                    } else {
                        this.toastr.error('Došlo je do greške. Molimo Vas obratite se korisničkoj podršci.');
                    }
                    this.ngOnInit();
                }
            );
        }

    }


    async upload(event) {
        this.myFiles = [];
        this.uploadService.setEvent(event);
        for (var i = 0; i < this.uploadService.eventData.target.files.length; i++) {
            this.myFiles.push(this.uploadService.eventData.target.files[i]);
        }
        let response = await this.uploadAndProgress(this.uploadService.eventData.target.files);
    }


    async uploadAndProgress(files: File[]) {
        const formData = new FormData();

        for (let i = 0; i < this.myFiles.length; i++) {
            formData.append("file[]", this.myFiles[i]);
        }

        let response = await this.uploadService.upload(formData);
        if (response['type'] === 'success') {
            this.commentAttachments = this.commentAttachments.concat(response['data']);
            this.uploadSuccess = true;
        } else {
            this.toastr.error('Došlo je do greške. Molimo Vas obratite se korisničkoj podršci.');
            return;
        }
    }


    onClick() {
        const fileUpload = this.fileUpload.nativeElement;
        fileUpload.click();
    }

    getUsers() {
        return new Promise((resolve, reject) => {
            const users = this.proventumApiService.getUsers().subscribe(data => {
                this.users = data;
                resolve();
            }, error1 => {
                reject(error1);
            });
        });

    }

    async validateTask(type) {
        const data = {
            id: this.taskId,
            validate: type,
            sort: this.task['sort']
        };


        const function1 = await this.taskService.validateTask(data).subscribe(async (response) => {
            if (response.type === 'success') {
                let message = type == false ?
                    'Validator ' + this.user['first_name'] + ' ' + this.user['last_name'] +
                    ' je odbio zahtjev za odobravanje zadatka. Zadatak je vraćen na ponovno izvršavanje.' :
                    'Validator ' + this.user['first_name'] + ' ' + this.user['last_name'] + ' je odobrio zadatak.';
                this.toastr.success(response.message);
                this.validatorPermission = false;

                let items: any = {
                    task_id: this.taskId,
                    user_id: parseInt(this.creator, 10),
                    type: 'validation',
                    action: 'insert',
                    trackTime: this.trackTime,
                    sort: this.sort,
                    message: message,
                    data: {validated: type},
                    task_identifier: this.task['identifier']

                };
                const function2 = await this.taskService.taskChange(items).subscribe((response: BackendResponse) => {
                    if (response.type == 'success') {
                        this.getTaskHistory();
                    }
                });
                ;


                let assignedArray: any[] = this.task['assigned'];
                let validatorsArray: any[] = this.task['validator_id'];
                let total: any[] = assignedArray.concat(validatorsArray);
                total = total.filter(item => item !== this.creatorId);

                if (total.length > 0) {
                    let link = this.cliUrl + '/view-task/' + this.task['_id'];
                    let notif = {
                        notification: {
                            title: message,
                            description: 'Zadatak: ' + this.title,
                            employers: total,
                            type: 'informacija',
                            link: link
                        }
                    };

                    const fun3 = await this.bridge.sendDataViaBridge(notif);
                }
                this.router.navigateByUrl('/home');


            } else if (response.type === 'info') {
                this.toastr.info(response.message);
                return;
            } else {
                this.toastr.error('Došlo je do greške. Molimo Vas obratite se korisničkoj podršci.');
            }
        });
    }

    removeAttachment(attachment) {
        this.uploadService.eventData = null;
        this.commentAttachments = this.commentAttachments.filter(x => x.name !== attachment.name);
    }


    getTaskDetails() {

        return new Promise(async (resolve, reject) => {

            try {
                this.validatorsData = [];
                this.taskValidators = [];
                const type = this.activateRoute.snapshot.routeConfig.path.split('/')[0];
                let response: Observable<any>;

                response = await this.taskService.getTaskData(this.taskId);


                response.subscribe(async (result) => {
                    if (result.type === 'success') {
                        this.task = result.data;
                        let data = result.data;

                        let checkArray: any[] = data['validator_id'].concat(data['assigned']);
                        checkArray.push(data['created_by']);
                        this.permission = checkArray.includes(this.creatorId);
                        this.type = data['type'];
                        this.title = data['title'];
                        this.description = data['description'] != null ? data['description'].replace(/<\/?[^>]+>/ig, ' ') : '';
                        this.project = data['project'];
                        this.taskViews = data['taskViews'];
                        this.progressProcent = data['progressProcent'];
                        this.attachments = data['attachments'];
                        this.status = data['status'];
                        this.execution = data['execution'];
                        this.deadline = data['type'] === 'task' ? data['deadline'].split(' ')[0] : null;
                        this.taskValidators = data['validator_id'];
                        this.identifier = data['identifier'];
                        if (data['type'] === 'meeting') {
                            this.meetingTime.start = data['meeting_time']['start'];
                            this.meetingTime.end = data['meeting_time']['end'];
                        }
                        if (data['type'] === 'reminder') {
                            this.reminderTime.start = data['reminder_time']['start'];
                        }
                        let id = parseInt(this.creator, 10);
                        if (this.taskValidators.length > 0) {
                            const i = this.taskValidators.indexOf(id);
                            if (i > -1) {
                                this.validatorPermission = true;
                            }
                        }

                        if (data['type'] !== 'task' && data['created_by'] === parseInt(this.creator, 10)) {
                            this.validatorPermission = true;
                        }


                        this.hashes = data['tags'];
                        this.createdAt = data['created_at'];
                        this.transformCreatedAtDateHandler();
                        this.estimateTime = data['estimateTime'];
                        this.deadline = data['deadline'];

                        this.comments = data['comments'];
                        this.allTaskWatchers = data['watcher_id'];
                        this.eye = (this.allTaskWatchers.indexOf(parseInt(this.creator)) > -1);
                        this.subtasksLength = this.subtasks.length;
                        this.sort = data['sort'];

                        this.subtasks = [];
                        if (this.sort === 'task') {
                            this.getSubtasks(this.taskId);
                        }

                        if (this.status === 'todo') {
                            this.buttonClass = 'status-button-todo';
                            this.statusName = 'Otvoreno';
                        } else if (this.status === 'postponed') {
                            this.buttonClass = 'status-button-postponed';
                            this.statusName = 'Odloženo';
                        } else if (this.status === 'canceled') {
                            this.buttonClass = 'status-button-canceled';
                            this.statusName = 'Otkazano';
                        } else if (this.status === 'inprogress') {
                            this.buttonClass = 'status-button-inprogress';
                            this.statusName = 'U radu';
                        } else if (this.status === 'ddone' || this.status === 'validated') {
                            this.buttonClass = 'status-button-done';
                            this.statusName = this.status === 'ddone' ? 'Završeno' : 'Odobreno';

                        } else {
                            this.buttonClass = 'status-button-deleted ';
                            this.statusName = 'Izbrisano';
                        }


                        const creatorData: any  = await this.getDataForId(this.task['created_by']);
			            this.taskCreatorData = creatorData;
                        if (creatorData === 0 || isNaN(creatorData))
                        {
                        	this.taskCreatorData = await this.getDataForId(this.task['assigned'][0])
                        }


                        const validators = await this.getDataForUsersById(this.task['validator_id']);
                        this.validatorsData = validators;

                        const assigned = await this.getDataForUsersById(this.task['assigned']);
                        this.assignedForTask = assigned;


                        const watchers = await this.getDataForUsersById(this.allTaskWatchers);
                        this.watchers = watchers;
                        this.previewTableWatchers = true;

                        this.history = data.history;
                        this.endTime = data['end_time'];
                    }
                });
                resolve();
            } catch (e) {
                reject(e);

            }

        });


    }

    goBack() {
        this.location.back();
    }


    getDataForId(id) {
        return new Promise((resolve, reject) => {
            try {
                let myArray: any[] = [];
                const y = Object.values(this.users).filter(x => x['id'] === id);
                if (y !== undefined) {
                    myArray = y;
                }
                resolve(myArray);
            } catch (error) {
                reject(error);
            }
        });
    }

    getDataForUsersById(array: any[]) {
        return new Promise((resolve, reject) => {
            try {
                const myArray = [];
                let count = 0;
                array.forEach(item => {
                    // @ts-ignore
                    const y = Object.values(this.users).find(x => x.id === item);
                    if (y !== undefined) {
                        myArray.push(y);
                    }
                });
                resolve(myArray);
            } catch (error) {
                reject(error);
            }
        });
    }

    getUserData() {
        return new Promise((resolve, reject) => {
            try {
                if (localStorage.getItem('userId') !== null) {
                    const fun2 = this.proventumApiService.getUser(localStorage.getItem('userId')).subscribe(data => {
                        this.user = data;
                        this.constants.setCreator(data.id);
                        this.constants.setUser(data);
                        resolve(true);
                    });
                }
            } catch (error) {
                reject(error);
            }
        });
    }

    transformCreatedAtDateHandler() {
        try {
            let today = new Date();
            let yesterday = new Date();

            let createdAt = new Date(this.createdAt);
            let time = createdAt.getHours() + ':' + ("0" + createdAt.getMinutes()).slice(-2);


            createdAt.setHours(0, 0, 0);

            yesterday.setDate(today.getDate() - 1);
            yesterday.setHours(0, 0, 0);


            if (createdAt.toDateString() == yesterday.toDateString()) {
                this.createdAtString = 'juče u ' + ' ' + time + 'h';
            } else {
                this.createdAtString = this.datePipe.transform(createdAt, 'dd.MM.yyyy') + ' ' + time + 'h';
            }
        } catch (e) {

        }

    }

    getDateStringInLocalLang(date) {
        let string = '';
        date = new Date(date);
        switch (new Date(date).getDay()) {
            case 0:
                string = 'Pon, ' + date.getDate();
                break;
            case 1:
                string = 'Uto, ' + date.getDate();
                break;
            case 2:
                string = 'Sri, ' + date.getDate();
                break;
            case 3:
                string = 'Čet, ' + date.getDate();
                break;
            case 4:
                string = 'Pet, ' + date.getDate();
                break;
            case 5:
                string = 'Sub, ' + date.getDate();
                break;
            case 6:
                string = 'Ned, ' + date.getDate();
                break;

            default:
                string = date;
        }
        switch (new Date(date).getMonth()) {
            case 0:
                string = string + ' jan';
                break;
            case 1:
                string = string + ' feb';
                break;
            case 2:
                string = string + ' mar';
                break;
            case 3:
                string = string + ' apr';
                break;
            case 4:
                string = string + ' maj';
                break;
            case 5:
                string = string + ' jun';
                break;
            case 6:
                string = string + ' jul';
                break;
            case 7:
                string = string + ' avg';
                break;
            case 8:
                string = string + ' sept';
                break;
            case 9:
                string = string + ' okt';
                break;
            case 10:
                string = string + ' nov';
                break;
            case 11:
                string = string + ' dec';
                break;

            default:
                string = string;
        }


        return string;


    }

// funkcija koju vraca attachment-thumbnails kad korisnik izbrise dokument
    deleteFileHandler(event) {
        let index = this.commentAttachments.findIndex(item => item.name === event.name);
        if (index > -1) {
            this.commentAttachments.splice(index, 1);
        }
    }

    appendClassesHandler() {

    }

    sidebarHandler() {


    }

    getTaskHistory() {
        this.taskService.getTaskHistory(this.taskId).subscribe((response: BackendResponse) => {
            if (response.type == 'success') {
                this.history = response.data;
            }
        }, error => {

        });
    }

    resizedTextAreaHandler() {
        this.resizedTextArea.nativeElement.style.height = 'auto';
        this.resizedTextArea.nativeElement.style.height = `${this.resizedTextArea.nativeElement.scrollHeight}px`;
    }

}
